import { BaseView, PromiseCompletionSource } from "scene-manager";
import { CommonUIResourcesPackage } from "../../common/resources/CommonUIResourcesPackage";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { NineSlicePlane } from "@pixi/mesh-extras";
import { TextStyle } from "@pixi/text";
import { IFocusable } from "../../../layers/IFocusable";
import { IDestroyOptions } from "@pixi/display";
import { LocalizedText } from "../../common/components/LocalizedText";
import { Localization } from "../../common/Localization";
import { ScaleUpButton } from "../../common/components/buttons/ScaleUpButton";
import { ScaleUpButtonWithText } from "../../common/components/buttons/ScaleUpButtonWithText";
import { getDefaultFontFamily } from "../../common/TextUtils";
import { AudioManager } from "../../../audio/AudioManager";

export class RetryView extends BaseView<boolean> implements IFocusable {

    public readonly focusable: boolean = true;

    private root: NineSlicePlane;
    private okButton: ScaleUpButtonWithText;
    private retryText: LocalizedText;
    private closeButton: ScaleUpButton;

    public constructor(
        private readonly canvasScaler: ICanvasScaler,
        private readonly commonResources: CommonUIResourcesPackage,
        private readonly localization: Localization,
        private readonly audioManager: AudioManager,
        operationControls: PromiseCompletionSource<boolean>
    ) {
        super(operationControls);
        this.build();
        this.layout();
    }

    public override start(): void {
    }

    private build(): void {
        this.root = new NineSlicePlane(this.commonResources.assets_common_root_png, 105, 150, 105, 150);
        this.root.width = 800;
        this.root.height = 416;
        this.addChild(this.root);
        this.okButton = new ScaleUpButtonWithText({
            defaultTexture: this.commonResources.assets_common_button_yellow_png,
            textOptions: {
                text: this.localization.getText("ok"),
                fontSize: 36,
                fill: 0xAA6B00,
                positionOption: {
                    x: 114.5,
                    y: 26.5
                },
                autoFitWidth: 210,
                autoFitHeight: 75
            }
        }, this.audioManager);
        this.root.addChild(this.okButton);
        this.closeButton = new ScaleUpButton({ defaultTexture: this.commonResources.assets_common_close_button_png }, this.audioManager);
        this.root.addChild(this.closeButton);
        this.retryText = new LocalizedText("restart_question", this.localization, new TextStyle({
            fontFamily: getDefaultFontFamily(),
            fontSize: 50,
            fill: "#4A5F66",
            align: "center"
        }), 450, 110);
        this.root.addChild(this.retryText);
        this.okButton.onUp.add(this.handleOkButtonClick, this);
        this.closeButton.onUp.add(this.handleCloseButtonClick, this);
    }

    private handleOkButtonClick(): void {
        this.operationControls.complete(true);
    }

    private layout(): void {
        const referenceWidth = this.canvasScaler.referenceWidth;
        this.root.position.set((referenceWidth - this.root.width) * 0.5, 570);
        this.closeButton.position.set(720, 40);
        this.retryText.position.set((this.root.width - this.retryText.width) * 0.5, 160);
        this.okButton.position.set((this.root.width - this.okButton.width) * 0.5, 290);
    }

    private handleCloseButtonClick(): void {
        this.operationControls.complete(false);
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.okButton.onUp.remove(this.handleOkButtonClick, this);
        this.closeButton.onUp.remove(this.handleCloseButtonClick, this);
        super.destroy(options);
    }
}